module.exports = __webpack_public_path__ + "static/img/posimg2.7e56cb9.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/posimg2.gif
// module id = cD6O
// module chunks = 1